import { c as _c } from "react/compiler-runtime";
import omit from 'lodash/omit';
import { useSearchParams } from 'next/navigation';
import { INVESTIGATION_ARTIFACT_PARAM, INVESTIGATION_CHAT_PARAM } from '@/config/constants';
const useInvestigationsListHref = () => {
  const $ = _c(2);
  const search = useSearchParams();
  let t0;
  if ($[0] !== search) {
    const listParams = omit(Object.fromEntries(search ?? []), [INVESTIGATION_CHAT_PARAM, INVESTIGATION_ARTIFACT_PARAM]);
    t0 = new URLSearchParams(listParams).toString();
    $[0] = search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const params = t0;
  return params ? `/investigations?${params}` : "/investigations";
};
export default useInvestigationsListHref;